import { create } from "zustand";
import { axiosInstance } from "../lib/axios.js";
import toast from "react-hot-toast";
import port from "../helper.js";
import { deleteProduct, dowloadProduct, getAllProduct, getProductByIdFunction, postProduct } from "../api/product.js";

export const useProductStore = create((set, get) => (
    {
        product: null,
        loading: false,

        addProduct: async (formData, id) => {
            try {
                set({ loading: true })
                const res = await postProduct(formData, id)
                // set({ category: res.ref })
                set({ loading: false })
                return res
            } catch (error) {
                console.log("Internal server error:", error);
                set({ loading: false });
                return false;
            } finally {
                set({ isCheckingAuth: false });
            }
        },
        getProduct: async (pageNumber, pageSize, search, field) => {
            try {
                set({ loading: true })
                const res = await getAllProduct(pageNumber, pageSize, search, field)
                set({ loading: false, product: res?.ref })
                return res
            } catch (error) {
                console.log("Internal server error:", error);
                set({ category: null });
                return false;
            }
        },
        getProductById: async (id) => {
            try {
                set({ loading: true })
                const res = await getProductByIdFunction(id)
                set({ loading: false })
                return res
            } catch (error) {
                console.log("Internal server error:", error);
                set({ category: null });
                return false;
            }
        },
        deleteproduct: async (id) => {
            try {
                set({ loading: true })
                const res = await deleteProduct(id)
                const currentProducts = get().product || [];
                const updatedProducts = currentProducts.filter((ele) => ele._id !== id);
                set({ loading: false, product: updatedProducts });
            } catch (err) {
                console.log("Internal server error:", err);
                set({ category: null });
                return false;
            }
        },
        getRecentProduct: async (pageNumber, pageSize, search, field) => {
            try {
                set({ loading: true })
                const res = await getAllProduct(pageNumber, pageSize, search, field)
                set({ loading: false })
                return res?.ref
            } catch (error) {
                console.log("Internal server error:", error);
                set({ category: null });
                return false;
            }
        },
        DowloadProduct: async (pageNumber, pageSize, search, field) => {
            try {
                set({ loading: true })
                const res = await dowloadProduct(pageNumber, pageSize, search, field)
                set({ loading: false })
                return res
            } catch (error) {
                console.log("Internal server error:", error);
                set({ category: null });
                return false;
            }
        },
    }
));
